
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/terms",
      function () {
        return require("private-next-pages/profile/terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/terms"])
      });
    }
  